// extracted by mini-css-extract-plugin
module.exports = {"research":"ContentResearch_research__3vow7","research__title":"ContentResearch_research__title__whi01"};